import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.9141 22H8.08594L12 18.0859L15.9141 22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.5 8H8.5V9H10.5V8Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 19.999L16.5352 20L12 15.4639L7.46484 20H1.00098L1 2.99902H23V19.999ZM8 6C7.32175 6 6.5 6.50067 6.5 7.42871V14H8.5V11H10.5V14H12.5V7.42871C12.5 6.50067 11.6783 6 11 6H8ZM13.5 6V8H14.5V12H13.5V14H17.5V12H16.5V8H17.5V6H13.5Z"}}]};

const ScreenMirroringFilled = Vue.extend<IconProps>({
  name: 'ScreenMirroringFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'screen-mirroring-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ScreenMirroringFilled;
